class AccountSettings.AcdRoundRobinWithAssignationLimitSettingView extends Backbone.View
  template: JST["backbone/templates/account_settings/acd_setting/round_robin_with_assignation_limit"]
  tagName: 'table'

  events:
    'change #acd-setting-assignation-limit': 'onAcdAssignationLimitChange'

  initialize: (@options = {}) ->
    @acdSetting = @options.acdSetting

  onAcdAssignationLimitChange: ->
    assignationLimit = parseInt(@$el.find("#acd-setting-assignation-limit").val()) || 0;
    typeSetting = {assignation_limit: assignationLimit}
    @acdSetting.set('operators_distribution_setting', typeSetting)

  render: =>
    @$el.html(@template(@))
    @

  validateSetting: =>
    I18n.t('monitoring.acd_setting.invalid_assignation_limit') if (@acdSetting.get('operators_distribution_setting').assignation_limit < 1)
